import React, { useEffect, useState } from 'react'
import { Card, Table } from 'react-bootstrap'
import NavSearch from '../layouts/AdminLayout/NavBar/NavLeft/NavSearch';
import { getServerURL } from '../helper/envConfig';
import api from '../helper/api';
import Loader from './Loader/Loader';
import PaginationC from './pagination';

const userShape = (props) => {

    const serverURL = getServerURL()
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true);
    const [paginationData, setPaginationData] = useState({})
    const [page, setPage] = useState(1)

    useEffect(() => {
        getUserQuery();
    }, [searchText, page]);

    useEffect(() => {
        if (searchText?.length) setPage(1);
    }, [searchText]);

    const getUserQuery = (event) => {
        api.getWithToken(`${serverURL}user/diamond-query/?page=${page}${searchText && `&_i=${searchText}`}`)
            .then(async (res) => {
                const { data, links, page, page_size, total, total_pages } = res?.data;
                setPaginationData({ links, page, page_size, total, total_pages })
                setLoading(false)
                if (res?.data?.success === true) {
                    setData(data);
                }
            })
            .catch((e) => {
                setLoading(false)
            });
    };

    return (
        <>
            <Card className="user-list">
                <Card.Header>
                    <div className='d-flex justify-content-between align-items-center'>
                        <Card.Title as="h4">{props?.title || ""}</Card.Title>
                        <div className='d-flex align-items-center'>
                            <header className="navbar pcoded-header" style={{ backgroundColor: "#fff" }}> <NavSearch searchText={searchText} setSearchText={setSearchText} /></header>
                        </div>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Table responsive hover>
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>User Id</th>
                                <th>Email</th>
                                <th>Shape</th>
                                <th>Color</th>
                                <th>Cut</th>
                                <th>Clarity</th>
                                <th>Fluorescence</th>
                                <th>Polish</th>
                                <th>Symmetry</th>
                                <th>Matters_text</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Boolean(loading) ?
                                <tr>
                                    <td colSpan={6} className='text-center'>
                                        <Loader loading={loading} />
                                    </td>
                                </tr>
                                :
                                Boolean(data?.length) ? data?.map((item, index) =>
                                    <tr>
                                        <td>{(10 * (page - 1)) + (index + 1)}</td>
                                        <td>
                                            <h6 className="m-0">{item?.user_id || "-"} </h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.email || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.diamond_shape || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.color || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.cut || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.clarity || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.fluorescence || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.polish || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.symmetry || "-"}</h6>
                                        </td>
                                        <td>
                                            <h6 className="m-0">{item?.matters_text || "-"}</h6>
                                        </td>
                                    </tr>
                                )
                                    :
                                    <tr>
                                        <td colSpan={11} className='text-center'>
                                            There are no records available at the moment.
                                        </td>
                                    </tr>
                            }
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {Boolean(data?.length) && paginationData?.total_pages > 1 &&
                <PaginationC data={paginationData}
                    onPageChange={(newPage) => {
                        setPage(newPage);
                    }} />
            }
        </>
    )
}

export default userShape